import { render } from "./FromProfile.vue?vue&type=template&id=fb4d2198"
import script from "./FromProfile.vue?vue&type=script&lang=ts"
export * from "./FromProfile.vue?vue&type=script&lang=ts"
script.render = render

export default script